/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Table, TableBody, TableContainer, TablePagination, Typography } from '@mui/material'
import { Empty } from 'antd'
import * as React from 'react'
import { useLocation } from 'react-router-dom'
import SadImage from '../../../common-images/SadImage'
import TableHeadComponent from '../../../components/GroupsTable/Table/TableHeadComponent'
import TablePaginationActions from '../../../components/GroupsTable/Table/TablePaginationActions'
import { HeadCell, NotifyGateway } from '../../../components/GroupsTable/types'
import Loader from '../../../components/Loader'
import { useGetGatewayOfflineLists } from '../../../hook/notifications'
import { useSessionContex } from '../../../SessionContex'
import TableRowNotificationComponent from './TableRowNotificationComponent'

interface MUINotificationTableProps {
  searchTerm: string
  setModalOpen: any
  setSnackBarInfo?: any
  modalOpen: boolean
}

export default function MUINotificationTable({
  searchTerm,
  setModalOpen,
  modalOpen,
  setSnackBarInfo
}: MUINotificationTableProps) {
  const [allSelected, setAllSelected] = React.useState<boolean>(false)
  const [page, setPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(10)
  const [totalNotification, setTotalNotification] = React.useState(0)
  const location = useLocation()
  const { id } = location.state?.data || {}

  console.log('Incident ID:', id)

  const { data: notificationLists, refetch, isLoading, isFetching } = useGetGatewayOfflineLists({ incident_id: id })
  const { reCall, setReCall } = useSessionContex()

  React.useEffect(() => {
    if (notificationLists?.total) {
      const totalLength = notificationLists.total?.split('/')[1]
      setTotalNotification(Number(totalLength))
    }
  }, [notificationLists])

  const rows: NotifyGateway[] = React.useMemo(() => {
    return notificationLists ? notificationLists.data.map(group => ({ ...group })) : []
  }, [notificationLists, page, rowsPerPage])

  React.useEffect(() => {
    refetch()
  }, [page, rowsPerPage])

  React.useEffect(() => {
    if (id) refetch()
  }, [searchTerm, id])

  React.useEffect(() => {
    if (reCall && id) {
      refetch().finally(() => setReCall(false))
    }
  }, [reCall, id, refetch, setReCall])

  React.useEffect(() => {
    if (!isLoading && !isFetching) {
      setReCall(false)
    }
  }, [isLoading, isFetching])

  React.useEffect(() => {
    setPage(0)
  }, [searchTerm])

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage)
    setAllSelected(false)
  }

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  // Custom label mapping for headers
  const headerLabels: Record<string, string> = {
    gw_uid: 'Gateway UID',
    stats_last_seen: 'Last Seen'
  }

  const headCells: HeadCell[] = React.useMemo(() => {
    return Object.keys(headerLabels).map(key => ({
      id: key, // Ensure ID is included for referencing
      disablePadding: key === 'gw_uid',
      label: headerLabels[key] || key.replace(/_/g, ' ').toUpperCase()
    }))
  }, [])

  return (
    <Box sx={{ width: '100%' }}>
      {isLoading || isFetching || reCall ? (
        <div className='flex justify-center items-center h-[60vh]'>
          <Loader />
        </div>
      ) : (
        <>
          {rows?.length !== 0 ? (
            <TableContainer sx={{ height: 'calc(64vh - 91px)' }}>
              <Table stickyHeader sx={{ minWidth: 750 }} aria-labelledby='tableTitle' size={'medium'}>
                <TableHeadComponent
                  rowCount={10}
                  headCells={headCells}
                  isAllSelected={allSelected}
                  isAction={true}
                  isCheckbox={true}
                />
                <TableBody>
                  {rows && rows?.map(row => <TableRowNotificationComponent key={row.id} row={row} />)}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Empty
              image={<SadImage />}
              className='flex flex-col items-center justify-center h-[50vh]'
              description={
                <div className='mt-4'>
                  <Typography variant='h5' component='h5' sx={{ fontSize: '32px', color: '#3D4854' }}>
                    No groups available.
                  </Typography>
                  <Typography component='p' sx={{ fontSize: '16px', color: '#3D4854' }}>
                    Create your first group by clicking the 'Add New' button.
                  </Typography>
                </div>
              }
            />
          )}

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'end',
              alignItems: 'center',
              paddingX: 2
            }}
          >
            <TablePagination
              rowsPerPageOptions={[10, 20, 30, 40, 50, 100, 500]}
              component='div'
              count={totalNotification}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </Box>
        </>
      )}
    </Box>
  )
}
